// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_uwEFJ","icon":"index_icon_mD8cl","title":"index_title_1FVBQ","menuIcon":"index_menuIcon_3x6cC"};